import { PolygonClippedGridSystem, extentFromPolygon, } from '@zwaarcontrast/ol-graticule';
import { ProjectedGridSystem, registerCRS, } from '@zwaarcontrast/ol-graticule-projected';
import { MBSFormatter } from '../formatters/MBSFormatter.js';
import { MBSIntervals } from '../intervals/MBSIntervals.js';
/**
 * Assemble a {@link PolygonClippedGridSystem} from an already-registered CRS, its
 * letter scheme, and a coverage polygon. An `MBSIntervals` drives both the inner
 * grid's line spacing and the clip system's cell snapping. Shared by every MBS
 * theatre factory; theatres that compute their own proj4 (Nord de Guerre's datum
 * override) register their CRS and call this directly with a fixed `extent`.
 */
export function assembleMBSGridSystem(crs, scheme, clip, projOptions, extent) {
    const intervals = new MBSIntervals();
    const inner = new ProjectedGridSystem({
        ...projOptions,
        crs,
        extent: extent ?? extentFromPolygon(clip, 50_000),
        formatter: new MBSFormatter(scheme),
        intervals,
    });
    return new PolygonClippedGridSystem({
        source: inner,
        clipPolygon: { rings: [clip], crs },
        cellSnapInterval: (resolution, viewProjection) => intervals.getInterval(resolution, viewProjection),
    });
}
/**
 * Register a theatre's CRS and build its clipped grid system. For theatres whose
 * proj4 string is a fixed constant; theatres that compute proj4 (Nord de Guerre's
 * datum override) register their own CRS and call {@link assembleMBSGridSystem}.
 */
export function createMBSGridSystem(crs, proj4, scheme, defaultClip, options) {
    registerCRS(crs, proj4);
    const { clipPolygon, ...projOptions } = options ?? {};
    return assembleMBSGridSystem(crs, scheme, clipPolygon ?? defaultClip, projOptions);
}
//# sourceMappingURL=shared.js.map